import { createContext, useContext, useEffect, useState } from "react";
import { translations } from "./translations";

const LanguageContext = createContext(null);

const resolve = (obj, path) => path.split(".").reduce((acc, key) => (acc == null ? undefined : acc[key]), obj);

export const LanguageProvider = ({ children }) => {
  const [lang, setLangState] = useState(() => localStorage.getItem("mi-lang") || "it");

  const setLang = (l) => {
    if (!translations[l]) return;
    localStorage.setItem("mi-lang", l);
    setLangState(l);
  };

  useEffect(() => {
    document.documentElement.lang = lang;
  }, [lang]);

  const t = (path, vars) => {
    let value = resolve(translations[lang], path);
    if (value === undefined) value = resolve(translations.it, path);
    if (value === undefined) return path;
    if (typeof value === "string" && vars) {
      Object.entries(vars).forEach(([k, v]) => { value = value.replaceAll(`{${k}}`, v); });
    }
    return value;
  };

  return (
    <LanguageContext.Provider value={{ lang, setLang, t }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLang = () => useContext(LanguageContext);
